/**
 * Formate un numéro de compteur (PDL 14 car., PCE 8 ou 14 car.) pour affichage.
 */
export function formatMeter(str: string | undefined | null): string {
    if (!str) return ""

    function insertString(s: string, newStr: string, position: number): string {
        return s.slice(0, position) + newStr + s.slice(position)
    }

    let newStr = str
    if (str.length === 14) {
        const format = "### ### ### ### ##"
        for (let i = 0; i < format.length; i++) {
            if (format[i] === " ") newStr = insertString(newStr, " ", i)
        }
    } else if (str.length === 8) {
        const format = "## ######"
        for (let i = 0; i < format.length; i++) {
            if (format[i] === " ") newStr = insertString(newStr, " ", i)
        }
    }
    return newStr
}

/** Valide un PDL (14 chiffres). */
export function pdlValidator(value: string | undefined | null): boolean {
    if (value == null || value === "") return false
    return /^\d{14}$/.test(value)
}

/** Valide un PCE (GIS… ou 14 chiffres). */
export function pceValidator(value: string | undefined | null): boolean {
    if (value == null || value === "") return false
    return /^[G][I][0-9]{6}$|^[0-9]{14}$/.test(value)
}

/** Vérifie que le PDL ressemble à un compteur Enedis (préfixe). */
export function pdlEnedisValidator(value: string | undefined | null): boolean {
    if (value == null || value === "") return true
    if (value.length < 3) return false
    const firstCharacters = parseInt(value.substring(0, 3), 10)
    if (Number.isNaN(firstCharacters)) return false
    return (
        firstCharacters <= 599 ||
        (firstCharacters >= 900 && firstCharacters <= 999)
    )
}
